import React, { useEffect } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import GuessPassword from '../../components/GuessPassword';

function Module8() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    setCanContinue(true);
  };

// Timer
const { timeRemaining, formatTime, isRunning } = useTimer();

// Determine additional classes dynamically
let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-8" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-alert">
                      <div id="box-wrapper-alert-header"></div>
                      <div id="box-wrapper-alert-body">
                        <h1>Crossword Reminder Questions</h1>
                        <div className="box-wrapper-alert-col-1">
                            <h2>Across</h2>
                            <ul className="list-no-bullets">
                                <li><strong>3.</strong> A virus is a type of what?</li>	 	
                                <li><strong>4.</strong> If it's public and free, it might be insecure?</li>	
                                <li><strong>5.</strong> If it's important, back this up.</li>
                                <li><strong>6.</strong> Report all fraud and cybercrime to ______ Fraud.</li>
                                <li><strong>9.</strong> If they ask for ________ information, question it.</li>
                            </ul>
                        </div>
                    
                        <div className="box-wrapper-alert-col-2">                
                            <h2>Down</h2>
                            <ul className="list-no-bullets">
                                <li><strong>1.</strong> Don't click if it's ______?</li>
                                <li><strong>2.</strong> The F in 2FA.</li>
                                <li><strong>7.</strong> Don't share everything on ____ Media.</li>
                                <li><strong>8.</strong> The random words make this password _______?</li>
                                <li><strong>9.</strong> Another name for an update.</li>
                            </ul>
                        </div>

                        {/* OFFLINE */}
                        <div className="box-wrapper-alert-answer">
                            <h2>Answer</h2>
                            <GuessPassword
                                hashedAnswer="1865e4f9be9639fc76d7d4da8ee25eaa7421f6837accb67516937e69469ea7e4" // SHA-256
                                onSuccess={handleSuccess}
                            >
                                <p>Please enter your answer:</p>
                            </GuessPassword>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module8;
